import { render, staticRenderFns } from "./InvitesFilter.vue?vue&type=template&id=923e2cce&"
import script from "./InvitesFilter.vue?vue&type=script&lang=js&"
export * from "./InvitesFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports